import * as Constants from '@/lib/constants'
import Vue from 'vue'

/**
 * vuetify-toast-snackbarのWrapperです
 *
 * https://www.npmjs.com/package/vuetify-toast-snackbar
 */
export default class Toast {
  static defaultOptions() {
    return {
      x: 'right',
      y: 'top',
      color: 'success',
      showClose: true,
      timeout: Constants.TOAST_DISMISS_INTERVAL,
    }
  }

  static i18nSuccess(messageId, params = {}) {
    const message = Vue.prototype.$tt(messageId, params)
    Toast.success(message)
  }

  static i18nError(messageId, params = {}) {
    const message = Vue.prototype.$tt(messageId, params)
    Toast.error(message)
  }

  static success(message, toastOptions = {}) {
    Vue.prototype.$toast(message, toastOptions)
  }

  static error(message, toastOptions = {}) {
    const opts = Object.assign(toastOptions, { color: 'red' })
    Vue.prototype.$toast(message, opts)
  }
}
